module.exports = __webpack_public_path__ + "img/cdbcb14c4c4df337fe1d96cfbaf28474.svg";